import { CookieRefreshOutlineIcon } from './CookieRefreshOutlineIcon';

/**
 * author: Colton Wiscombe
 * id CA84B827-73C5-4C28-AC8B-82AADD5469E9
 * name cookie-refresh-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-refresh-outline.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitRefreshOutlineIcon = CookieRefreshOutlineIcon;
export default BiscuitRefreshOutlineIcon